import { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { SNACKBAR } from 'store/constant';

function useApi(
    apiServiceFunction,
    handleSuccess = () => { },
    showSuccessAlert = false,
    immediate = false,
    handleError = () => { }
) {

    const [status, setStatus] = useState('idle');
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    const { enqueueSnackbar } = useSnackbar();

    const execute = useCallback(
        (...args) => {
            setStatus('pending');
            setResponse(null);
            setError(null);
            return apiServiceFunction(args)
                .then((response) => {
                    setResponse(response);
                    setStatus('success');
                    handleSuccess(response);
                    if (showSuccessAlert) enqueueSnackbar(response.message, SNACKBAR.success);
                })
                .catch((error) => {
                    setError(error);
                    setStatus('error');
                    returnError(error);
                });
        },
        [apiServiceFunction]
    );

    function returnError(error) {
        let errorData = error ? error.data : null;
        if (errorData && errorData.message) {
            enqueueSnackbar(errorData.message, SNACKBAR.error);
            let errors = errorData.errors;
            if (errors) {
                errors.forEach((item) => {
                    enqueueSnackbar(item, SNACKBAR.error);
                });
            }
        } else {
            enqueueSnackbar('Oops! Something went wrong', SNACKBAR.error);
        }
        handleError(error);
    }

    useEffect(() => {
        if (immediate) {
            execute();
        }
    }, [execute, immediate]);

    return { execute, status, response, error };
}

export default useApi;